var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_admin)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('inventory-performance'),expression:"'inventory-performance'"}],staticClass:"m-l-15",attrs:{"variant":"success"}},[_c('i',{staticClass:"bi bi-box-seam m-r-5"}),_vm._v(" Inventario ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }